import React from 'react';

interface HtmlPreviewProps {
  html: string;
  className?: string;
}

export function HtmlPreview({ html, className = '' }: HtmlPreviewProps) {
  return (
    <div 
      className={`border rounded-md p-4 bg-white ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
} 